export const CUSTOMER_NEW = "New Customer";
export const CUSTOMER_EXISTING = "Existing Customer";

export const CONTACT_PHONE = "Contact via Phone";
export const CONTACT_EMAIL = "Contact via Email";

export const ENQUIRY_DESC_2_DAYS = "An Audi Financial Services representative will respond to your enquiry typically within 1-2 business days to discuss your enquiry.";
export const ENQUIRY_DESC_3_HOURS = "An Audi Financial Services representative will respond to your enquiry typically within 1-3 business hours to discuss your enquiry.";

export const REQUEST_TYPES = {

    // new customers
    REQUEST_QUOTE:              "Request a quote",
    FINANCE:                    "Finance or Insurance Options",
    RATES:                      "Rates",
    CAMPAIGN:                   "Current finance offer",

    // Existing customers
    PHONE_TEXT_RECEIVED:        "Text message recently received",
    PHONE_OVERDUE_ACCOUNT:      "Discuss an overdue account",
    PHONE_PAYMENT_ARRANGEMENTS: "Make a payment arrangement",
    PHONE_REQUEST_DOCUMENTS:    "Request a statement, payout letter or contract",
    PHONE_UPDATE_INFORMATION:   "Update personal or direct debit information",
    PHONE_CURRENT_BALANCE:      "Current balance enquiry",

    EMAIL_REQUEST_DOCUMENT:     "Request document",
    EMAIL_OVERDUE_ACCOUNT:      "Overdue account enquiry",
    EMAIL_UPDATE_INFORMATION:   "Update information",
    EMAIL_REFINANCE:            "Refinance Enquiry",
    EMAIL_OTHER:                "All other enquiries ", // notice the white space at the end - this differentiates it from the OTHER option !!

    //Common
    OTHER:                      "All other enquiries",

    // Request types - requets documents
    DOCUMENTS_STATEMENT:        "Statement",
    DOCUMENTS_PAYOUT_LETTER:    "Payout letter",
    DOCUMENTS_CONTRACT:         "Contract",

    // Request types - overdue account
    OVERDUE_MAKE_PAYMENT:       "I would like to make a payment",
    OVERDUE_DEFER_PAYMENT:      "I would like to defer a payment",
    OVERDUE_RETURN_VEHICLE:     "I would like to return my vehicle",

    // Request type update information
    UPDATE_DIRECT_DEBIT:        "Update direct debit details",
    UPDATE_ADDRESS:             "Update address or postal address",
    UPDATE_PERSONAL_INFORMATION:"Update personal information",
    UPDATE_REGISTRATION_NUMBER: "Update registration number",

    // Request types - other
    OTHER_PAYOUT:               "Payout figure or balance",
    OTHER_CONFIRM_RECEIPT:      "Confirm receipt of payment",
    OTHER_RESIDUAL_BALLOON:     "Residual or balloon enquiry",
};

// options for new customers
export const OPTS_NEW = [
    {label: "Request a quote", value: REQUEST_TYPES.REQUEST_QUOTE},
    {label: "Finance or Insurance Options", value: REQUEST_TYPES.FINANCE},
    {label: "Rates", value: REQUEST_TYPES.RATES},
    {label: "Current finance offer", value: REQUEST_TYPES.CAMPAIGN},
    {label: "All other enquiries", value: REQUEST_TYPES.OTHER}
];

// options for existing customers with contact by phone
export const OPTS_EX_PHONE = [
    {label: "Text message recently received", value: REQUEST_TYPES.PHONE_TEXT_RECEIVED},
    {label: "Discuss an overdue account", value: REQUEST_TYPES.PHONE_OVERDUE_ACCOUNT},
    {label: "Make a payment arrangement", value: REQUEST_TYPES.PHONE_PAYMENT_ARRANGEMENTS},
    {label: "Request a statement, payout letter or contract", value: REQUEST_TYPES.PHONE_REQUEST_DOCUMENTS}, // ENQUIRY_DESC_3_HOURS
    {label: "Update personal or direct debit information", value: REQUEST_TYPES.PHONE_UPDATE_INFORMATION}, // ENQUIRY_DESC_3_HOURS
    {label: "Current balance enquiry", value: REQUEST_TYPES.PHONE_CURRENT_BALANCE}, // ENQUIRY_DESC_3_HOURS
    {label: "All other enquiries", value: REQUEST_TYPES.OTHER} // ENQUIRY_DESC_3_HOURS
];

export const OPTS_EX_EMAIL = [
    {value: REQUEST_TYPES.EMAIL_REQUEST_DOCUMENT,         label:"Request document"},
    {value: REQUEST_TYPES.EMAIL_OVERDUE_ACCOUNT,          label:"Overdue account enquiry"},
    {value: REQUEST_TYPES.EMAIL_UPDATE_INFORMATION,       label:"Update information"},
    {value: REQUEST_TYPES.EMAIL_REFINANCE,                label:"Refinance Enquiry"},
    {value: REQUEST_TYPES.EMAIL_OTHER,                    label:"All other enquiries"},
];

export const OPTS_EX_EMAIL_SUB = {
    [REQUEST_TYPES.EMAIL_REQUEST_DOCUMENT]: [
        {label: "Statement", value: "Statement"},
        {label: "Payout letter", value: "Payout letter"},
        {label: "Contract", value: "Contract"},
        {label: "Other document", value: "Other"}
    ],
    [REQUEST_TYPES.EMAIL_OVERDUE_ACCOUNT]: [
        {label: "I would like to make a payment", value: "I would like to make a payment"},
        {label: "I would like to defer a payment", value: "I would like to defer a payment"},
        {label: "I would like to return my vehicle", value: "I would like to return my vehicle"},
        {label: "Other overdue account enquiry", value: "Other"}
    ],
    [REQUEST_TYPES.EMAIL_UPDATE_INFORMATION]: [
        {label: "Update direct debit details", value: "Update direct debit details"},
        {label: "Update address or postal address", value: "Update address or postal address"},
        {label: "Update personal information", value: "Update personal information"},
        {label: "Update registration number", value: "Update registration number"},
        {label: "Update other information", value:"Other"}
    ],
    [REQUEST_TYPES.EMAIL_OTHER]: [
        {label: "Payout figure or balance", value: "Payout figure or balance"},
        {label: "Confirm receipt of payment", value: "Confirm receipt of payment"},
        {label: "Residual or balloon enquiry", value: "Residual or balloon enquiry"},
        {label: "Other enquiry", value: "Other"}
    ]
};
